import { logout } from '@features/auth';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useAutoDisconnect = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const hasDisconnected = sessionStorage.getItem('hasAutoDisconnected');

        if (!hasDisconnected) {
            dispatch(logout());
            sessionStorage.setItem('hasAutoDisconnected', 'true');
        }
    }, [dispatch]);
};
